/** Word Wheel Quest — App Store pricing (CAD). */

export const WORD_WHEEL_QUEST_CURRENCY = "CAD";

/** Must match backend PayPlanAppCode / mo_apps.code. */
export const WORD_WHEEL_QUEST_APP_CODE = "word_wheel_quest";

/** Backend IAP catalog group for credit packs. */
export const WORD_WHEEL_CREDIT_PRODUCT_GROUP = "appleWordWheelQuest";

/** Backend IAP catalog group for hint point packs. */
export const WORD_WHEEL_POINTS_PRODUCT_GROUP = "appleWordWheelQuestPoints";

export const WORD_WHEEL_LOW_CREDITS_BALANCE = 10;

export const WORD_WHEEL_LOW_HINT_POINTS_BALANCE = 5;

/**
 * IAP credit packs (list prices in CAD).
 * @type {{ productId: string, packageKey: string, label: string, priceCad: number, creditsAwarded: number }[]}
 */
export const WORD_WHEEL_CREDIT_IAP_PRODUCTS = [
    {
        productId: "com.pzl.word.wheel.quest.pocket",
        packageKey: "pocket",
        label: "Pocket",
        priceCad: 4.99,
        creditsAwarded: 50,
    },
    {
        productId: "com.pzl.word.wheel.quest.pro",
        packageKey: "pro",
        label: "Pro",
        priceCad: 9.99,
        creditsAwarded: 110,
    },
    {
        productId: "com.pzl.word.wheel.quest.masterpass",
        packageKey: "masterpass",
        label: "Master Pass",
        priceCad: 19.99,
        creditsAwarded: 650,
    },
];

/**
 * IAP hint point packs (list prices in CAD).
 * @type {{ productId: string, packageKey: string, label: string, priceCad: number, creditsAwarded: number }[]}
 */
export const WORD_WHEEL_POINTS_IAP_PRODUCTS = [
    {
        productId: "com.pzl.word.wheel.quest.points.pocket",
        packageKey: "points_pocket",
        label: "Points Pocket",
        priceCad: 2.99,
        creditsAwarded: 25,
    },
    {
        productId: "com.pzl.word.wheel.quest.points.pro",
        packageKey: "points_pro",
        label: "Points Pro",
        priceCad: 5.99,
        creditsAwarded: 60,
    },
    {
        productId: "com.pzl.word.wheel.quest.points.masterpass",
        packageKey: "points_masterpass",
        label: "Points Master Pass",
        priceCad: 12.99,
        creditsAwarded: 150,
    },
];

const amountFormatter = new Intl.NumberFormat("en-CA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

/** @param {number} amount */
export function formatWordWheelQuestPrice(amount) {
    return `$${amountFormatter.format(amount)} ${WORD_WHEEL_QUEST_CURRENCY}`;
}

/** @param {unknown} catalog */
export function extractWordWheelProductGroup(catalog, groupKey) {
    if (!Array.isArray(catalog)) {
        return [];
    }
    const group = catalog.find((entry) => entry?.group === groupKey);
    return Array.isArray(group?.products) ? group.products : [];
}

/**
 * Merge server catalog rows with local display metadata.
 * @param {Array<{ productId: string, creditsAwarded?: number }>} serverProducts
 * @param {typeof WORD_WHEEL_CREDIT_IAP_PRODUCTS} localProducts
 */
export function mergeWordWheelProducts(serverProducts, localProducts) {
    const serverById = new Map(
        (serverProducts || []).map((row) => [row.productId, row])
    );
    return localProducts.map((local) => {
        const server = serverById.get(local.productId);
        return {
            ...local,
            creditsAwarded: Number(server?.creditsAwarded ?? local.creditsAwarded),
        };
    });
}
